import type {z} from "zod";

import {UpdateLeadBody} from "@project/sdk/sales/zod";
import {z as zod} from "zod";

import {requiredStringSchema} from "../../../../../shared/validation/required-string.schema";
import {leadFieldLabelIds} from "../../../messages/leads.messages";

const updateCompany = UpdateLeadBody.shape.company;
const updateProfile = updateCompany.shape.partyProfile;
const updatePhone = updateProfile.shape.phone;

export const updateLeadCompanyNameSchema = requiredStringSchema(
  updateCompany.shape.companyName,
  leadFieldLabelIds.companyName,
);
export const updateLeadAddressSchema = requiredStringSchema(
  updateProfile.shape.address.shape.address,
  leadFieldLabelIds.address,
);

export const updateLeadFormSchema = zod.object({
  companyName: updateLeadCompanyNameSchema,
  address: updateLeadAddressSchema,
  country: updateProfile.shape.country,
  phoneNumber: updatePhone.shape.nationalNumber,
  phonePrefix: updatePhone.shape.regionCode,
  websiteUrl: updateProfile.shape.websiteUrl,
  logoUrl: UpdateLeadBody.shape.logoUrl,
  type: UpdateLeadBody.shape.environments,
});
export type UpdateLeadFormPayload = z.output<typeof updateLeadFormSchema>;

export const draftUpdateLeadFormSchema = updateLeadFormSchema.partial();
export type DraftUpdateLeadFormPayload = z.output<typeof draftUpdateLeadFormSchema>;
